// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   BUTTON - G42 BRANDING
   ========================================== */

.interview-button {
  width: 100%;
  padding: 14px var(--interview-space-xl);
  border: none;
  border-radius: var(--interview-radius-lg);
  font-size: var(--interview-text-base);
  font-weight: var(--interview-text-semibold);
  cursor: pointer;
  transition: all var(--interview-transition-base);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--interview-space-sm);
  font-family: var(--interview-font-primary);
  letter-spacing: -0.01em;
}

.interview-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.interview-button-primary {
  background-color: var(--interview-brand-primary);
  color: var(--interview-bg-white);
}

.interview-button-primary:hover:not(:disabled) {
  background-color: var(--interview-brand-primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--interview-shadow-button);
}

.interview-button-primary:active:not(:disabled) {
  transform: translateY(0);
}

.interview-button-secondary {
  background-color: var(--interview-bg-card);
  color: var(--interview-text-secondary);
}

.interview-button-secondary:hover:not(:disabled) {
  background-color: var(--interview-border-default);
}

.interview-button-icon {
  font-size: var(--interview-text-md);
}
`, "",{"version":3,"sources":["webpack://./src/components/Interview/shared/Button.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C;EACE,WAAW;EACX,uCAAuC;EACvC,YAAY;EACZ,yCAAyC;EACzC,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,gCAAgC;AAClC;;AAEA;EACE,sDAAsD;EACtD,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/* ==========================================\n   BUTTON - G42 BRANDING\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n.interview-button {\n  width: 100%;\n  padding: 14px var(--interview-space-xl);\n  border: none;\n  border-radius: var(--interview-radius-lg);\n  font-size: var(--interview-text-base);\n  font-weight: var(--interview-text-semibold);\n  cursor: pointer;\n  transition: all var(--interview-transition-base);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--interview-space-sm);\n  font-family: var(--interview-font-primary);\n  letter-spacing: -0.01em;\n}\n\n.interview-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.interview-button-primary {\n  background-color: var(--interview-brand-primary);\n  color: var(--interview-bg-white);\n}\n\n.interview-button-primary:hover:not(:disabled) {\n  background-color: var(--interview-brand-primary-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--interview-shadow-button);\n}\n\n.interview-button-primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.interview-button-secondary {\n  background-color: var(--interview-bg-card);\n  color: var(--interview-text-secondary);\n}\n\n.interview-button-secondary:hover:not(:disabled) {\n  background-color: var(--interview-border-default);\n}\n\n.interview-button-icon {\n  font-size: var(--interview-text-md);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
